export const ClientTypes = {
  PERSON: 'Persona',
  COMPANY: 'Empresa'
}